module.exports = __webpack_public_path__ + "static/media/coursesAndBatches.78099e61.svg";